var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueHex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 115,
    viewBox: "0 0 119 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5292 105.699C30.9977 112.026 38.5865 115.38 46.2734 114.424L83.7221 109.768C91.047 108.858 97.3559 104.168 100.339 97.4167L116.571 60.6866C119.554 53.9351 118.774 46.1131 114.516 40.0839L92.7459 9.25927C88.2773 2.93212 80.6885 -0.421376 73.0017 0.534277L35.5529 5.19002C28.2281 6.10067 21.9191 10.7901 18.9356 17.5415L2.70448 54.2717C-0.278987 61.0231 0.501137 68.8452 4.75926 74.8743L26.5292 105.699Z",
    fill: "#8568BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueHex);
export default __webpack_public_path__ + "static/media/BlueHex.756f9a424633d09e5c76256423443977.svg";
export { ForwardRef as ReactComponent };